module.exports = __webpack_public_path__ + "img/homepage.4b8392ed.png";